import { call, put, takeLatest } from "redux-saga/effects"
import { axiosRestInstance } from "../../../common/axios";
import { AxiosResponse } from "axios";
import {
  notificationSagaActionTypes,
  notificationPayloadType
} from "./saga-actions";
import { NotificationType } from "../../slices/notification/Types";
import { notificationSliceAction } from "../../slices/notification";

type notificationAPIResponseType = {
    success: boolean;
    message: string;
    data: NotificationType[];
};

const getNotificationListAPI = async () => {
    const response = await axiosRestInstance.get<AxiosResponse<notificationAPIResponseType>>('/notification/');
    return response.data;
};

const addNotificationAPI = async (payload: notificationPayloadType) => {
    const response = await axiosRestInstance.post('/notification/add', payload);
    return response.data;
};

const updateNotificationAPI = async (payload: notificationPayloadType) => {
    const response = await axiosRestInstance.put(`/notification/update/${payload.ID}`, payload);
    return response.data;
};

const deleteNotificationAPI = async (ID: number) => {
    const response = await axiosRestInstance.delete(`/notification/delete/${ID}`);
    return response.data;
};

// Sagas Below
function* getNotificationListSaga(action: {
    type: string;
}) {
    try {
        yield put(notificationSliceAction.setNotificationListLoading(true));
        const response: notificationAPIResponseType = yield call(getNotificationListAPI);
        yield put(notificationSliceAction.setNotificationList(response.data ?? []))
        yield put(notificationSliceAction.setNotificationListLoading(false));
    } catch (e) {
        yield put(notificationSliceAction.setNotificationListLoading(false));
        console.error("Error fetching notifications", e);
    }
}

function* addNotificationSaga(action: {
    type: string;
    payload: notificationPayloadType 
}) {
    try {
        yield call(addNotificationAPI, action.payload);
    } catch (e) {
        console.error("Error adding notification", e);
    }
}

function* updateNotificationSaga(action: {
    type: string;
    payload: notificationPayloadType 
}) {
    try {
        yield call(updateNotificationAPI, action.payload);
    } catch (e) {
        console.error("Error updating notification", e);
    }
}

function* deleteNotificationSaga(action: {
    type: string;
    payload: { ID: number } 
}) {
    try {
        yield call(deleteNotificationAPI, action.payload.ID);
    } catch (e) {
        console.error("Error deleting notification", e);
    }
}

function* notificationSaga() {
    yield takeLatest(notificationSagaActionTypes.callGetNotificationListSaga, getNotificationListSaga);
    yield takeLatest(notificationSagaActionTypes.callAddNotificationSaga, addNotificationSaga);
    yield takeLatest(notificationSagaActionTypes.callUpdateNotificationSaga, updateNotificationSaga);
    yield takeLatest(notificationSagaActionTypes.callDeleteNotificationSaga, deleteNotificationSaga);
}

export default notificationSaga;
